import { VerticalArrowDropzoneIcon } from '@ui/kit/icons';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../../hook.task-breakpoints.js';
import { tokens, emptyDropzone, placeholder } from './atom.empty.style.js';
import { jsx } from 'react/jsx-runtime';

function EmptyDropzone(props) {
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const ratio = isMobile ? 0.025 : 0.1;
  return /*#__PURE__*/jsx("div", {
    ref: props.setNodeRef,
    className: emptyDropzone,
    "data-over": props.isOver,
    "data-transparent": !props.settings.visibleDropzones,
    style: tokens.__override({
      top: `${props.dropzone.placement.y * 100}%`,
      left: `${props.dropzone.placement.x * 100}%`,
      width: `${props.dropzone.placement.width * props.scale}px`,
      height: `${props.dropzone.placement.height * props.scale}px`,
      padding: `${Math.min(8, props.dropzone.placement.height * props.scale * ratio, props.dropzone.placement.width * props.scale * ratio) + 2}px`
    }),
    children: props.settings.visibleDropzones && /*#__PURE__*/jsx("div", {
      className: placeholder,
      children: /*#__PURE__*/jsx(VerticalArrowDropzoneIcon, {})
    })
  });
}

export { EmptyDropzone };
//# sourceMappingURL=atom.empty.js.map
